/* eslint-disable no-shadow */
enum FeatureFlagEnum {
  ShowCardPeople = "showCardPeople",
  JobTitleManagement = "jobTitleManagement",
  CostCenterManagement = "costCenterManagement",
  TimeShiftManagement = "timeShiftManagement",
  HourlyBasisLimitDate = "hourlyBasisLimitDate",
  HasExcusedAbsences = "hasExcusedAbsences",
  UsesPerformanceReview = "usesPerformanceReview",
  UsesEmployeeFeedbacks = "usesEmployeeFeedbacks",
  UsesInfringements = "usesInfringements",
  UsesJobEngineer = "usesJobEngineer",
  UsesComptimeEmployeeBalance = "usesComptimeEmployeeBalance"
}
export default FeatureFlagEnum;
